module.exports = __webpack_public_path__ + "img/action-D.be695034.svg";